import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AppLayout from "./components/layout/AppLayout";
import ErrorBoundary from "./components/ui/ErrorBoundary";

const Login = lazy(() => import("./pages/Login"));
const Dashboard = lazy(() => import("./pages/Dashboard/index"));
const Settings = lazy(() => import("./pages/Settings/index"));
const LibraryManagement = lazy(() => import("./pages/LibraryManagement/index"));
const Users = lazy(() => import("./pages/Users/index"));
const Projects = lazy(() => import("./pages/Projects/index"));
const ForestWealthFlow = lazy(() => import("./pages/ForestWealthFlow/index"));

const Unauthorized = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-100">
    <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md text-center">
      <h1 className="text-2xl font-bold text-red-500 mb-2">Unauthorized</h1>
      <p className="text-gray-600">
        You do not have permission to access this page.
      </p>
    </div>
  </div>
);

const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-ns-canvas text-sm text-gray-500">
    Loading...
  </div>
);

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ErrorBoundary>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/unauthorized" element={<Unauthorized />} />

              {/* Protected routes wrapped in layout */}
              <Route
                element={
                  <ProtectedRoute>
                    <AppLayout />
                  </ProtectedRoute>
                }
              >
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/users" element={<Users />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/library" element={<LibraryManagement />} />
              </Route>

              {/* Full-screen flow — no admin sidebar */}
              <Route
                path="/forest-wealth-flow"
                element={
                  <ProtectedRoute>
                    <ForestWealthFlow />
                  </ProtectedRoute>
                }
              />

              {/* Catch all - redirect to login */}
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          </Suspense>
        </ErrorBoundary>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
